import { useCallback } from 'react'
import { BulkAddNoteFormType } from '../typings'
import type { FormikErrors } from 'formik'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import { createLeadNoteBulk } from '@user/store/leadNotes/api'
import { toast } from '@sales-center/components'
import { getLeadList } from '@user/store/lead'
import { createOpportunityNoteBulk } from '@user/store/opportunityNotes/api'
import { getOpportunities } from '@user/store/opportunity'

type Props = {
  entityType: ENTITY_TYPES
  onClose?: () => void
}

export function useHandlers(props: Props) {
  const { entityType, onClose } = props
  const dispatch = useAppDispatch()

  const onSubmit = useCallback(
    async (model: BulkAddNoteFormType) => {
      if (entityType == ENTITY_TYPES.Lead) {
        const response = await dispatch(createLeadNoteBulk(model))
        if (createLeadNoteBulk.fulfilled.match(response)) {
          toast.success(`Note created.`)
          dispatch(getLeadList(false))
          onClose && onClose()
        } else {
          toast.error(`Failed to create note.`)
        }
      }
      if (entityType == ENTITY_TYPES.Opportunity) {
        const response = await dispatch(createOpportunityNoteBulk(model))
        if (createOpportunityNoteBulk.fulfilled.match(response)) {
          toast.success(`Note created.`)
          dispatch(getOpportunities(false))
          onClose && onClose()
        } else {
          toast.error(`Failed to create note.`)
        }
      }
    },
    [dispatch, onClose, entityType],
  )

  const validate = useCallback((model: BulkAddNoteFormType) => {
    const errors: FormikErrors<BulkAddNoteFormType> = {}

    const { Note, addToPestPacLocation, noteCode } = model

    if (!Note || Note?.trim().length === 0) {
      errors.Note = 'Please enter a note'
    }

    if (addToPestPacLocation) {
      if (!noteCode) errors.noteCode = 'Required'
    }
    return errors
  }, [])

  return { onSubmit, validate }
}
